<template>
  <section
    :id="macroAnimation.id"
    :key="macroAnimation.ref"
    :style="{
      top: macroAnimation.position ? macroAnimation.position.top : 0,
      left: macroAnimation.position ? macroAnimation.position.left : 0,
      width: macroAnimation.width ? macroAnimation.width : null,
      height: macroAnimation.height ? macroAnimation.height : null
    }"
    class="lottie-ani-handler no-flicker"
  >
    <lottie
      ref="lottie"
      class="lottie-ani-handler__lottie-wrapper"
      v-on:animCreated="handleAnimation"
    ></lottie>
    <!-- <button @click="pause">THIS IS A PAUSE BUTTON</button> -->
  </section>
</template>

<script>
import Lottie from "@/assets/vue-lottie";
import { mapState, mapMutations, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "lottie-ani-handler",
  components: {
    lottie: Lottie
  },
  props: ["callTypeWriter", "onFinish"],
  data() {
    return {
      timeOut: "",
      timeOuts: [],
      localStopTimeIdx: 0,
      animationStepSkipped: false,
      hasVoiceOverEnded: true,
      baseUrl: process.env.VUE_APP_BASE_URL,
      resolveAudio: undefined,
      hide: false
    };
  },
  computed: {
    ...mapState({
      macroAnimation: state => state.moduleMacroAnimations.macroAnimation,
      voiceOver: state => state.audio.voiceOver,
      stopTimeIdx: state => state.textBox.stopTimeIdx
    })
  },
  methods: {
    ...mapMutations([
      "updateShowTextBox",
      "updateShowIcon",
      "updateGoToPoint",
      "updateProgressBarWidth",
      "updateStopTimeIdx",
      "setTotalVoiceOverTime",
      "updateVoiceOverTime",
      "updateWaitProgress",
      "setVoiceOver",
      "updateCurrentVoiceOverName",
      "updatePlayTimeout"
    ]),
    ...mapActions(["getTechnologyLandscapeTextBox"]),
    fetchData(string, json) {
      return new Promise((resolve, reject) => {
        axios.get(string + json).then(res => {
          resolve(res.data);
        });
      });
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    play() {
      // This function sets everything back to default, adds listeners, and starts animation.
      this.localStopTimeIdx = 0;
      this.currentTime = 0;
      this.setTotalVoiceOverTime(0);
      this.updateVoiceOverTime(0);
      this.hasVoiceOverEnded = true;
      this.stopTime = this.macroAnimation.stopTimes.stopTimes[0].stopTime;
      this.anim.goToAndPlay(1, true);
      this.anim.addEventListener("enterFrame", this.showTextInBox);
    },
    voiceOverEnded() {
      if (
        this.stopTimeIdx ===
        this.macroAnimation.stopTimes.stopTimes.length - 1
      ) {
        return;
      }
      this.setTotalVoiceOverTime(0);
      this.updateVoiceOverTime(0);
      this.hasVoiceOverEnded = true;
      this.clearVoiceOver();
      this.showTextInBox();
    },
    animationComplete() {
      // called when animation has completed
      this.updateStopTimeIdx(this.localStopTimeIdx);
      this.clearVoiceOver();
      this.updateWaitProgress(0);
      this.anim.removeEventListener("enterFrame", this.showTextInBox);
      this.anim.removeEventListener("complete", this.animationComplete);
      this.createVoiceOver(
        this.macroAnimation.stopTimes.stopTimes[this.localStopTimeIdx]
          .voiceOver,
        true
      ).then(() => {
        this.updateCurrentVoiceOverName(
          this.macroAnimation.stopTimes.stopTimes[this.localStopTimeIdx]
            .voiceOver
        );
        let playTimeout = setTimeout(
          () => {
            this.voiceOver.play();
          },
          process.env.VUE_APP_TOUCHPOINT_DATA_SET === "browser" ? 2000 : 0
        );
        this.updatePlayTimeout(playTimeout);
      });
      if (
        this.macroAnimation.stopTimes.stopTimes[this.localStopTimeIdx]
          .goToPoint !== undefined
      ) {
        this.updateGoToPoint(
          this.macroAnimation.stopTimes.stopTimes[this.localStopTimeIdx]
            .goToPoint
        );
      }
    },
    skipAnimationSection() {
      this.hasVoiceOverEnded = true;
      this.animationStepSkipped = true;
      this.clearVoiceOver();
      this.anim.goToAndPlay(
        this.macroAnimation.stopTimes.stopTimes[this.localStopTimeIdx].stopTime,
        true
      );
      this.updateWaitProgress(0);
    },

    resumeAnimation() {
      this.createVoiceOver(
        this.macroAnimation.stopTimes.stopTimes[this.localStopTimeIdx].voiceOver
      ).then(() => {
        this.updateCurrentVoiceOverName(
          this.macroAnimation.stopTimes.stopTimes[this.localStopTimeIdx]
            .voiceOver
        );
        if (
          this.macroAnimation.stopTimes.stopTimes[this.localStopTimeIdx]
            .goToPoint !== undefined
        ) {
          this.updateGoToPoint(
            this.macroAnimation.stopTimes.stopTimes[this.localStopTimeIdx]
              .goToPoint
          );
        }
        let playTimeout = setTimeout(() => {
          this.updateStopTimeIdx(this.localStopTimeIdx);
          this.changeStopTime();
          this.hide = false;
        }, 0);
        playTimeout = setTimeout(() => {
          this.voiceOver.play();
          this.anim.play();
        }, 2000);
        this.updatePlayTimeout(playTimeout);
      });
    },
    pause() {
      // pauses animation
      this.anim.pause();
    },
    stop() {
      if (this.anim) {
        this.anim.stop();
        for (let i = 0; i < this.timeOuts.length; i++) {
          clearTimeout(this.timeOuts[i]);
        }
        // Clear the timeOuts array
        this.timeOuts = [];
      }
    },
    changeStopTime() {
      // this changes the stop time object so that we get different text and icon at each stop.
      this.localStopTimeIdx++;
      this.stopTime = this.macroAnimation.stopTimes.stopTimes[
        this.localStopTimeIdx
      ].stopTime;
    },

    showTextInBox(e) {
      if (e && e.currentTime) {
        this.currentTime = e.currentTime;
      }
      if (this.currentTime >= this.stopTime) {
        this.pause();
        this.hide = true;
        if (this.hasVoiceOverEnded === true) {
          if (
            this.localStopTimeIdx ===
            this.macroAnimation.stopTimes.stopTimes.length - 1
          ) {
            this.animationComplete();
            return;
          }
          this.hasVoiceOverEnded = false;
          this.resumeAnimation();
        }
      }
    },

    createVoiceOver(audio, animationIsComplete) {
      return new Promise((resolve, reject) => {
        if (this.voiceOver === undefined) {
          this.setVoiceOver(new Audio("/voice-overs/" + audio));
        } else {
          let tempVo = this.voiceOver;
          tempVo.src = "/voice-overs/" + audio;
          this.setVoiceOver(tempVo);
        }
        if (animationIsComplete) {
          this.voiceOver.addEventListener("ended", this.lastVoiceOver);
        } else {
          this.voiceOver.addEventListener("ended", this.voiceOverEnded);
        }
        this.voiceOver.addEventListener("loadedmetadata", this.getTotalVOTime);
        resolve();
      });
    },
    lastVoiceOver() {
      this.clearVoiceOver();
      this.getTechnologyLandscapeTextBox();
    },
    getTotalVOTime() {
      this.setTotalVoiceOverTime(this.voiceOver.duration);
      this.setDurationListener();
    },
    setDurationListener() {
      this.voiceOver.addEventListener("timeupdate", this.getCurrentVOTime);
    },
    getCurrentVOTime() {
      this.updateVoiceOverTime(this.voiceOver.currentTime);
    },
    clearVoiceOver() {
      if (this.voiceOver) {
        this.voiceOver.removeEventListener("ended", this.lastVoiceOver);
        this.voiceOver.removeEventListener("ended", this.voiceOverEnded);
        this.voiceOver.removeEventListener(
          "loadedmetadata",
          this.getTotalVOTime
        );
        this.voiceOver.removeEventListener("timeupdate", this.getCurrentVOTime);
      }
    }
  },
  mounted() {
    this.fetchData(
      "/json-animations/macro/",
      this.macroAnimation.animation
    ).then(res => {
      this.defaultOptions = {
        renderer: "svg",
        animationData: res,
        autoplay: false,
        loop: false,
        rendererSettings: {
          progressiveLoad: true,
          clearCanvas: true,
          hideOnTransparent: true,
          className: `lottie-section`
        }
      };
      this.$refs.lottie.load(this.defaultOptions);
    });
  },
  beforeDestroy() {
    this.clearVoiceOver();
  },
  destroyed() {
    this.defaultOptions = {};
    this.anim.destroy();
    this.$destroy();
  }
};
</script>

<style scoped lang="scss">
.lottie-ani-handler {
  position: absolute;
  &__lottie-wrapper {
    position: relative;
    width: 100%;
    zoom: 100%;
  }
  .hide {
    display: none;
  }
}
button {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%);
}
</style>
